import { ORDER_STATUS, SERVICE_TYPES } from '@bagonboard/wiseman';
import { objOf, pipe } from 'ramda';
import React, { useEffect, useMemo } from 'react';
import { useHistory } from 'react-router-dom';

import { useCompanies, useOrders } from '#views/Dashboard/hooks';
import FilterInput from '../../../components/FilterInput';
import TableDateRange from '../../../components/TableDateRange/TableDateRange';
import TableMultiSelect from '../../../components/TableDateRange/TableMultiSelect';
import { getQueryStringFilter } from '../../../modules/getUrls';
import {
  Amount, Code, Created, Details, Email, Name, Seller, Status,
} from './components';

const servicesTypesToFilter = [SERVICE_TYPES.CHECKIN, SERVICE_TYPES.SKIP_BAGGAGE_CLAIM];

function Orders() {
  const history = useHistory();
  const { companies, handlers: companiesHandlers } = useCompanies();
  const { orders, handlers: ordersHandlers } = useOrders();
  useEffect(() => {
    companiesHandlers.fetch({
      select: ['code', 'name'],
    }, { enableSnackbar: true });
  }, [companiesHandlers.fetch]);

  orders.filters = { ...orders.filters, serviceType: servicesTypesToFilter };
  const query = useMemo(() => getQueryStringFilter(orders.filters),
    [JSON.stringify(orders.filters)]);

  useEffect(() => {
    ordersHandlers.fetchStringQuery(query, { enableSnackbar: true });
  }, [ordersHandlers.fetchStringQuery, query]);

  const orderStatus = Object.entries(ORDER_STATUS).map(([_id, code] = []) => ({
    value: code,
    text : _id,
  }));

  const orderCompanies = companies.data ? companies.data.map(({ _id, code }) => ({
    value: _id,
    text : code,
  })) : [];

  const columns = [
    {
      Header  : 'Status',
      accessor: 'status',
      Cell    : Status,
      minWidth: 104,
      sortable: false,
      Filter  : TableMultiSelect({
        id             : 'Status',
        labelText      : 'Status',
        dataTableLength: orders.data.length,
        options        : orderStatus,
      }),
    },
    {
      Header  : 'Seller',
      accessor: 'resellerCompany.code',
      Cell    : Seller,
      minWidth: 80,
      sortable: false,
      Filter  : TableMultiSelect({
        id             : 'Seller',
        labelText      : 'Seller',
        dataTableLength: orders.length,
        options        : orderCompanies,
      }),
    },
    {
      Header  : 'Order code',
      accessor: 'bookingCode',
      Cell    : Code,
      minWidth: 130,
      sortable: false,
      Filter  : props => <FilterInput placeholder="6 digits code" {...props} />,
    },
    {
      Header  : 'Full name',
      accessor: 'customer',
      Cell    : Name,
      minWidth: 130,
      sortable: false,
      Filter  : props => <FilterInput placeholder="Name and surname" {...props} />,
    },
    {
      Header  : 'Email',
      accessor: 'customer.email',
      Cell    : Email,
      minWidth: 130,
      sortable: false,
      Filter  : props => <FilterInput placeholder="Email..." {...props} />,
    },
    {
      Header    : 'Created',
      accessor  : 'createdAt',
      Cell      : Created,
      minWidth  : 130,
      sortable  : true,
      filterable: false,
    },
    {
      Header    : 'Amount',
      accessor  : 'invoice',
      Cell      : Amount,
      minWidth  : 130,
      sortable  : true,
      filterable: false,
    },
    {
      Header    : '',
      accessor  : '_id',
      sortable  : false,
      filterable: false,
      minWidth  : 130,
      Cell      : props => <Details history={history} {...props} />,
    },
  ];

  return (
    <TableDateRange
      data={orders.data}
      filters={orders.filters}
      loading={orders.loading}
      columns={columns}
      total={orders.total}
      dataFetch={pipe(
        objOf('payload'),
        ordersHandlers.setFilters
      )}
    />
  );
}

export default Orders;
